
export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Advanced AES-256 encryption protocol ensures your data remains completely secure and protected from any unauthorized access or cyber threats.',
      highlight: true
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access our extensive network of high-performance servers located in over 50 countries worldwide for optimal connection speeds.',
      highlight: false
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Lightning Fast Speed',
      description: 'Experience blazing-fast internet speeds with our optimized infrastructure designed for seamless browsing and streaming.',
      highlight: false
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Zero-Log Policy',
      description: 'We never track, collect, or store your online activities. Your privacy is completely protected with our strict no-log policy.',
      highlight: false
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices simultaneously with our cross-platform compatibility for Windows, Mac, iOS, and Android.',
      highlight: false
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Expert Support',
      description: 'Get instant help from our dedicated security experts available around the clock to assist with any technical questions.',
      highlight: false
    }
  ];

  return (
    <section id="features" className="py-20 bg-[#F7F9FC]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-4">
            <div className="w-2 h-2 bg-[#00D9FF] rounded-full mr-3"></div>
            <span className="text-[#00D9FF] font-semibold uppercase tracking-wider text-sm">FEATURES</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#0A1628] mb-6 leading-tight">
            Why Choose<br />
            <span className="text-[#00D9FF]">ELTROM VPN</span>
          </h2>
          <p className="text-lg text-[#6B7B93] max-w-3xl mx-auto leading-relaxed">
            Advanced security features designed for modern digital protection, 
            ensuring your online privacy and data security at all times.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Featured Card - Larger */}
          <div className="lg:col-span-1">
            <div className="bg-[#0A1628] rounded-3xl p-8 h-full text-white relative overflow-hidden">
              <div className="relative z-10">
                <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-6">
                  <i className="ri-shield-check-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Military-Grade Encryption</h3>
                <p className="text-white/80 leading-relaxed">
                  Advanced AES-256 encryption protocol ensures your data remains completely secure 
                  and protected from any unauthorized access or cyber threats.
                </p>
              </div>
              
              {/* Background Pattern */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#00D9FF]/10 rounded-full -translate-y-8 translate-x-8"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-8 -translate-x-8"></div>
            </div>
          </div>

          {/* Regular Cards */}
          <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-8">
            {features.slice(1).map((feature, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-shadow duration-300 group cursor-pointer">
                <div className="w-12 h-12 bg-[#00D9FF] rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${feature.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#0A1628] mb-3">{feature.title}</h3>
                <p className="text-[#6B7B93] leading-relaxed text-sm">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Stats */}
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-8">
          {[
            { number: '50+', label: 'Server Locations', icon: 'ri-global-line' },
            { number: '256-bit', label: 'AES Encryption', icon: 'ri-shield-line' },
            { number: '99.9%', label: 'Uptime Guarantee', icon: 'ri-time-line' },
            { number: '24/7', label: 'Expert Support', icon: 'ri-customer-service-line' }
          ].map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-sm border border-gray-100 group-hover:shadow-lg transition-all duration-300">
                <i className={`${stat.icon} text-2xl text-[#00D9FF] group-hover:scale-110 transition-transform duration-300`}></i>
              </div>
              <div className="text-2xl lg:text-3xl font-bold text-[#0A1628] mb-2">{stat.number}</div>
              <div className="text-[#6B7B93] font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
